import * as Sentry from '@sentry/browser';

/**
 * Sets the publishable key on the legacy Stripe.js v2 global.
 *
 * `window.Stripe` is typed as the v3 `StripeConstructor` (via
 * @stripe/stripe-js), but some pages load the legacy v2 script whose global
 * exposes `setPublishableKey`. This helper defensively checks that the method
 * is actually available before calling it, and reports unexpected states and
 * failures to Sentry.
 */
export function setPublishableKey(publishableKey: string): void {
  const legacyStripe = window.Stripe as unknown as
    | { setPublishableKey?: (key: string) => void }
    | undefined;

  if (!legacyStripe) {
    return;
  }

  if (typeof legacyStripe.setPublishableKey !== 'function') {
    Sentry.captureMessage(
      'window.Stripe is present but Stripe.setPublishableKey is not a function',
    );
    return;
  }

  try {
    legacyStripe.setPublishableKey(publishableKey);
  } catch (error) {
    Sentry.captureException(error);
  }
}
